import CreateAxiosInstance from './axiosConfig';
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

// CS tooling (Diffit admins). Errors carry the API's message, shown in the component.
const handledInComponent = { customErrorHandler: () => {} };

export async function getDistricts() {
  return await APIClient.get('/district');
}

export async function getDistrictSetup(schoolRecordId) {
  return await APIClient.get(`/district/setup/${schoolRecordId}`);
}

export async function createDistrict({
  schoolRecordId,
  subscriptionEndDate,
  licenseCount,
  orgIds,
}) {
  return await APIClient.post(
    '/district',
    { schoolRecordId, subscriptionEndDate, licenseCount, orgIds },
    handledInComponent
  );
}

export async function updateDistrict(districtId, { name, subscriptionEndDate, licenseCount }) {
  return await APIClient.patch(
    `/district/${districtId}`,
    { name, subscriptionEndDate, licenseCount },
    handledInComponent
  );
}

export async function deleteDistrict(districtId) {
  return await APIClient.delete(`/district/${districtId}`, handledInComponent);
}

export async function linkOrgToDistrict(districtId, orgId) {
  return await APIClient.post(`/district/${districtId}/orgs/${orgId}`, {}, handledInComponent);
}

export async function unlinkOrgFromDistrict(districtId, orgId) {
  return await APIClient.delete(`/district/${districtId}/orgs/${orgId}`, handledInComponent);
}

export async function setDistrictMember(districtId, email, role) {
  return await APIClient.put(
    `/district/${districtId}/members`,
    { email, role },
    handledInComponent
  );
}

export async function removeDistrictMember(districtId, userId) {
  return await APIClient.delete(`/district/${districtId}/members/${userId}`, handledInComponent);
}

// District admins (and Diffit admins).
export async function getMyDistricts() {
  return await APIClient.get('/district/mine', handledInComponent);
}

export async function getDistrictDashboard(districtId) {
  // A 403 is the page's own "not available" state, not a global error.
  return await APIClient.get(`/district/${districtId}/dashboard`, handledInComponent);
}

// District office actions (district admins and Diffit admins). Each returns the District
// office: { people, invites }. Errors carry the API's message, shown in the component.
export async function addDistrictPeople(districtId, emails, role) {
  return await APIClient.post(
    `/district/${districtId}/people`,
    { emails, role },
    handledInComponent
  );
}

export async function changeDistrictPersonRole(districtId, userId, role) {
  return await APIClient.patch(
    `/district/${districtId}/people/${userId}`,
    { role },
    handledInComponent
  );
}

export async function removeDistrictPerson(districtId, userId) {
  return await APIClient.delete(`/district/${districtId}/people/${userId}`, handledInComponent);
}

export async function changeDistrictInviteRole(districtId, inviteId, role) {
  return await APIClient.patch(
    `/district/${districtId}/invites/${inviteId}`,
    { role },
    handledInComponent
  );
}

export async function deleteDistrictInvite(districtId, inviteId) {
  return await APIClient.delete(`/district/${districtId}/invites/${inviteId}`, handledInComponent);
}
